export function normalizeTeamLogoUrl(url: string): string {
  const match = url.match(/^(.*\/)([^/?#]+)\/teams\/([^/?#]+)\.([a-z0-9]+)([?#].*)?$/i);
  if (!match) {
    return url;
  }

  const [, prefix, sport, teamCode, currentExt, suffix = ''] = match;
  const expectedExt = sport.toLowerCase() === 'nba' ? 'png' : currentExt.toLowerCase();

  if (currentExt.toLowerCase() === expectedExt) {
    return url;
  }

  return `${prefix}${sport}/teams/${teamCode}.${expectedExt}${suffix}`;
}
